import { MemberInfo } from "@/types/member";

export function memberNormalizer(member: any): MemberInfo {
  // Defensive: fallback for missing nested fields
  const otherAttrs = member.other_attrs || {};
  return {
    isExperienced:
      typeof otherAttrs.isExperienced === "boolean"
        ? otherAttrs.isExperienced
        : false,
    family_member_type: member.family_member_type,
    id: member.id,
    firstName: member.first_name,
    middleName: member.middle_name,
    lastName: member.last_name,
    dob: member.dob,
    dobYear: member.dob_year,
    current_family: member.current_family,
    dobMonth: member.dob_month,
    dobDay: member.dob_day,
    email: member.email,
    dialCode: member.dialCode,
    mobile: member.mobile,
    status: member.status,
    lastLogin: member.lastLogin,
    roleType: member.roleType,
    memberType: member.member_type,
    derivedMemberType: member.derivedMemberType,
    relationship: member.relationship,
    gender: typeof member.gender === "number" ? member.gender : undefined,
    other_attrs: member.other_attrs,
    familyId: member.family_id,
    nickname: member.nickname,
    avatar: member.avatar,
    emergencyCardReady: member.emergencyCardReady,
    onBehalf: false,
    registered_member: !!member.registered_member,
    registration_status: member.registration_status,
    isSuspended: !!member.isSuspended,
    role_id: member.role_id,
  };
}
